/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance, flow } from 'mobx-state-tree';
import { AxiosResponse } from 'axios';
import axios from 'server';
import { AdminModel, IAdminModel } from './models/admin.model';
import { AdminsView } from './types';
import { toFormatDateTime } from 'utils';

const { model, string, array, number, maybeNull, reference } = types;

export const AdminsTableStore = model('AdminsTableStore', {
  admins: array(AdminModel),
  selectedIds: array(number),
  clickedId: number,
  selectedStatus: string,
  filter: string,
  clickedAdmin: maybeNull(reference(AdminModel)),
})
  .views((self) => ({
    get adminsView(): AdminsView[] {
      const alladminsView: AdminsView[] = [];
      for (let i = 0; i < self.admins.length; i++) {
        alladminsView.push({ ...self.admins[i], id: i });
      }

      if (!self.filter) {
        return alladminsView;
      }
      const regexp = new RegExp(self.filter, 'i');
      return alladminsView.filter(({ givenname, mail, createtimestamp, sn, modifytimestamp }) =>
        regexp.test(`${givenname}${sn}${mail}${toFormatDateTime(createtimestamp)}${toFormatDateTime(modifytimestamp)}'
        `)
      );
    },

    get CurrentClickedUser() {
      return self.clickedAdmin;
    },
  }))

  .actions((self) => ({
    clearClickedUser() {
      self.clickedAdmin = null;
    },
  }))
  .volatile(() => ({}))
  .actions((self) => ({
    clearSelected(): void {
      self.clickedAdmin = null;
    },
  }))
  .actions((self) => ({
    normalizeadmins({ data }: AxiosResponse): IAdminModel[] {
      self.clearSelected();
      // self.admins.replace(data.data);
      const normalizedData = data.data.map((admins: any) => ({
        ...admins,
        mail: admins.mail || admins.uid || 'no-email',
      }));
      self.admins.replace(normalizedData);
      return self.admins;
    },
    setClickedUser(dn: string): void {
      self.clickedAdmin = self.admins.find((user) => user.dn === dn) || null;
    },
    setSelectedIds(data: any): void {
      self.selectedIds.replace(data);
    },
    setClickedId(clickedId: number): void {
      self.clickedId = clickedId;
      localStorage.setItem('clickedId', JSON.stringify(self.clickedId));
    },

    setFilter(filter: string) {
      self.filter = filter;
    },
  }))
  .actions((self) => ({
    getAdmins: flow(function* () {
      const result = yield axios
        .get<IAdminModel[]>(`ldap/users/admins`)
        .then(self.normalizeadmins)
        .catch((error) => {
          throw new Error('Failed to create user due to an unexpected error');
        });
      return result;
    }),
    lockUser: flow(function* (dn: string, notifyStatus: boolean, permission: string) {
      const clickedUser = self.admins.find((user) => user.dn === dn) || null;
      if (!clickedUser) {
        throw new Error(`Can't find user by this dn: ${dn}`);
      }
      const result = yield axios
        .put<IAdminModel>(`ldap/users/${dn}`, {
          base: clickedUser.base,
          userpassword: clickedUser.userpassword,
          locked: !clickedUser.locked,
          notify: notifyStatus,
          updatedBy: permission,
        })
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });

      return result;
    }),
  }));

export type IAdminsTableStore = Instance<typeof AdminsTableStore>;
